import Vue from 'vue';

import {
    ALL,
    ADD_TO_CART,
    REMOVE_FROM_CART,
    RESET
} from './mutation-types';

export default {
    [ALL] (state, products) {
        state.all = products;
    },

    [ADD_TO_CART] (state, product) {
        let record = null;

        if (product.selectedVariants) {
            record = state.all.find(p => {
                if (p.selectedVariants) {
                    return (p.id === product.id) && (_.isEqual(p.selectedVariants.sort(), product.selectedVariants.sort()));
                } else {
                    return false;
                }
            });
        } else {
            record = state.all.find(p => p.id === product.id);
        }

        if (!record) {
            let productPrice = product.price;

            for (let variant of product.selectedVariants) {
                if (variant.price > 0) {
                    productPrice = productPrice + variant.price;
                }
            }

            state.all.push({
                id: product.id,
                name: product.name,
                personalisation: product.personalisation,
                price: productPrice,
                imageThumbUrl: product.images.length ? product.images[0].thumb_url : null,
                imageTinyThumbUrl: product.images.length ? product.images[0].tiny_thumb_url : null,
                selectedVariants: product.selectedVariants,
                quantity: 1
            });
        } else {
            record.quantity++;
        }

        localStorage.setItem(`cart_products`, JSON.stringify(state.all));
    },

    [REMOVE_FROM_CART] (state, index) {
        state.all.splice(index, 1);
        localStorage.setItem('cart_products', JSON.stringify(state.all));
    },

    [RESET] (state) {
        state.all = [];
    }
};
